import { ReactElement } from 'react';
import {
  BooleanInput,
  Edit,
  Labeled,
  ReferenceField,
  SimpleForm,
  TextField,
  useCanAccess,
} from 'react-admin';
import EditToolbar from '../../Components/EditToolbar';
import ActionPanel from './ActionPanel';
import { Divider, Grid2 as Grid } from '@mui/material';
import JsonApiHasOneReferenceInput from '../../Components/JsonApiHasOneReferenceInput';
import MappingRuleResource from '../../Entities/MappingRules';

export default function MappingRulesEdit(): ReactElement {
  const merchantListAccess = useCanAccess({ action: 'list', resource: 'merchants' });
  const categoryListAccess = useCanAccess({ action: 'list', resource: 'categories' });

  const prefetch: string[] = [];
  if (merchantListAccess.canAccess) prefetch.push('merchant');
  if (categoryListAccess.canAccess) prefetch.push('category');

  return (
    <Edit queryOptions={{ meta: { prefetch } }}>
      <SimpleForm toolbar={<EditToolbar />}>
        <Grid container spacing={2}>
          <Labeled>
            <ReferenceField
              reference="merchants"
              source="relationships.merchant.data.id"
              label="Merchant"
            />
          </Labeled>
          <Labeled>
            <TextField source="attributes.external_category" label="External Category" />
          </Labeled>
        </Grid>
        <Divider flexItem sx={{ mt: 2, mb: 2 }} />
        <JsonApiHasOneReferenceInput<MappingRuleResource>
          label="Category"
          optionText="attributes.full_name"
          reference="categories"
          referenceInputProps={{ filter: { level: 0 } }}
          source="relationships.category"
        />
        <BooleanInput
          defaultValue={false}
          label="Ignore New Offers Matching Rule In Scan"
          source="attributes.ignored"
        />
        <BooleanInput
          defaultValue={false}
          label="Should be hidden by default in CMS"
          source="attributes.is_hidden"
        />
        <Divider flexItem sx={{ mt: 2, mb: 2 }} />
        <ActionPanel />
      </SimpleForm>
    </Edit>
  );
}
